import { PaymentDiscountDto } from "../../services/tables/dto/payment-discount-dto";

export type PaymentType = 'ONLINE' | 'OFFLINE';
export type DiscountType = 'PERCENTAGE' | 'FIXED';

export class PaymentDiscount {
  id: number;
  paymentId: number | null;
  paymentType: PaymentType;
  discountType: DiscountType;
  discountValue: number;
  minimumValue: number;
  startAt: string | null;
  finishAt: string | null;
  appliesToFreight: number;

  constructor(dto: PaymentDiscountDto) {
    this.id = dto.id;
    this.paymentId = dto.paymentId;
    this.paymentType = dto.paymentType;
    this.discountType = dto.discountType;
    this.discountValue = dto.discountValue;
    this.minimumValue = dto.minimumValue;
    this.startAt = dto.startAt;
    this.finishAt = dto.finishAt;
    this.appliesToFreight = dto.appliesToFreight;
  }
}

